import templateUrl from './category-form.html';

export default {
  templateUrl,
  bindings: {
    category: '<',
    dialogTitle: '@',
    submitTitle: '@',
    categoryChanged: '&'
  },
  controller: class CategoryFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.categoryChanged(
        this.EventEmitter({
          category: this.category
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/categories/category-form/category-form.component.js